var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2667 8.60065V11.4007C11.2667 13.734 10.3334 14.6673 8.00008 14.6673H5.20008C2.86674 14.6673 1.93341 13.734 1.93341 11.4007V8.60065C1.93341 6.26732 2.86674 5.33398 5.20008 5.33398H8.00008C10.3334 5.33398 11.2667 6.26732 11.2667 8.60065Z",
    stroke: "#0A49A5",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2667 4.60065V7.40065C15.2667 9.73398 14.3334 10.6673 12.0001 10.6673H11.2667V8.60065C11.2667 6.26732 10.3334 5.33398 8.00008 5.33398H5.93341V4.60065C5.93341 2.26732 6.86674 1.33398 9.20008 1.33398H12.0001C14.3334 1.33398 15.2667 2.26732 15.2667 4.60065Z",
    stroke: "#0A49A5",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.9245746c872ce291f4b515f70b8ce766.svg";
export { ForwardRef as ReactComponent };